import { render, staticRenderFns } from "./editsysconfig.vue?vue&type=template&id=36025154"
import script from "./editsysconfig.vue?vue&type=script&lang=js"
export * from "./editsysconfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports